import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { CompanySettingsModel, Currency } from '../models'
import { CompanySettingsApi } from '../../services/CompanySettingsApi'

const defaultState: CompanySettingsModel = {
    name: '',
    oib: '',
    telephone: '',
    mobile: '',
    fax: '',
    contactEmail: '',
    website: '',
    bankAccount: '',
    street: '',
    defaultUiLanguage: '',
    streetNumber: '',
    city: '',
    postalCode: '',
    addressArea: '',
    country: '',
    defaultMailReceiptText: '',
    defaultMailTenderText: '',
    showCompanyName: false,
    showCompanyOib: false,
    showCompanyAddress: false,
    showCompanyTelephone: false,
    showCompanyMobile: false,
    showCompanyFax: false,
    showCompanyEmail: false,
    showCompanyWebSite: false,
    showCompanyBankAccount: false,
    hasMultipleValutes: false,
    defaultTenderCurrency: Currency.EUR,
    defaultReceiptCurrency: Currency.EUR,
    editPurchasePrice: false,
    canChangeVat: false,
    defaultCurrency: Currency.EUR,
    defaultVat: 0,
    defaultTenderNote: '',
    defaultReceiptPaymentTerms: '',
    lastEnteredMargin: 0,
    lastEnteredRebate: 0,
    isAccountingVat: false,
    hideGroups: false,
    hideSimilarProducts: false,
    defaultTenderLanguageId: '',
    showProductDimensionsInfo: false,
    enterFullPriceEnabled: false,
    units: [],
    isFiscalizationModuleActive: false,
    isFiscalizationActive: false,
}

interface CompanyStore {
    companySettings: CompanySettingsModel
    companyLoaded: boolean
    loadCompany: () => Promise<void>
    setCompanySettings: (companySettings: CompanySettingsModel) => void
    resetCompanySettings: () => void
}

export const useCompanyStore = create<CompanyStore>()(
    persist(
        set => ({
            companySettings: { ...defaultState },
            companyLoaded: false,
            setCompanySettings: (companySettings: CompanySettingsModel) => set({ companySettings: { ...companySettings } }),
            resetCompanySettings: () => set({ companySettings: { ...defaultState }, companyLoaded: false }),
            loadCompany: async () => {
                const companySettings = await CompanySettingsApi.get()

                set({ companySettings: { ...companySettings }, companyLoaded: true })
            },
        }),
        {
            name: 'company-storage',
        }
    )
)
